<script>
  export let src;
  export let width;
  export let height;
  export let alt;
</script>

<div class="diagram-image">
  <img class="diagram-image__img" {src} {width} {height} {alt} loading="lazy" />
</div>

<style lang="scss">
  .diagram-image {
    &__img {
      aspect-ratio: 900/195;
      margin-top: 5rem;
      width: 100%;
    }
  }
</style>
